import useSessionStore from 'stores/useSessionStore';

export const hasRole = (roleCd: string) => {
  return useSessionStore.getState().roleCodes.includes(roleCd);
};
